import {
    authorizedGetCall,
    authorizedPostCall,
    authorizedPutCall,
    authorizedDeleteCall,
} from "./APIsService";

export const getNotifications = () => {
    return new Promise((resolve, reject) => {
        authorizedGetCall(`notifications`)
            .then((data) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const sendNotification = (data) => {
    return new Promise((resolve, reject) => {
        authorizedPostCall(`notifications`, data)
            .then((data) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const scheduleNotification = (data) => {
    return new Promise((resolve, reject) => {
        authorizedPostCall(`notifications/schedule`, data)
            .then((data) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const deleteNotification = (id) => {
    return new Promise((resolve, reject) => {
        authorizedDeleteCall(`notifications/${id}`)
            .then((data) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
